import React, { Component } from 'react';
import { Modal } from 'react-responsive-ui'
import PropTypes from 'prop-types';
import Loading from './Loading';
import { getEcgImageWithId } from '../helpers/registrationHelper';

class ECGImage extends Component {

  constructor(props) {
    super(props);
    this.state = {
        imgPath: null
    }
    this.getEcgImage = this.getEcgImage.bind(this)
    this.getEcgImage(props.item.id)
  }

    getEcgImage(id) {
    getEcgImageWithId(id)
     .then((response) => {
       if(response.data) {
         return response.data.ecg
       }
     })
     .then(ecg => {
       this.setState({imgPath: ecg})
     })
  }
  render() {
      return (
      <span>
        {this.state.imgPath ? <span className="ecg-img-container" onClick={() => { this.setState({showModal: true})}}><img className="ecg-image" src={this.state.imgPath }/></span> : this.props.item.ecg_image_id && <Loading/> }
        <Modal
          isOpen={this.state.showModal}
          close={() => this.setState({ showModal: false })}>
          <img className="ecg-image-modal" src={this.state.imgPath }/>
        </Modal>
        </span>
      )
  }
}

ECGImage.propTypes = {
history: PropTypes.object,
item: PropTypes.object
};


export default ECGImage;


// WEBPACK FOOTER //
// ./src/components/ECGImage.js